import DashboardView from "../views/DashboardView.vue";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
const routes = [
  {
    path: "/dashboard",
    component: DashboardLayout,
    children: [
      {
        path: "",
        name: "Dashboard",
        component: DashboardView,
        meta: {
          permissions: "baret_navbar:dashboard",
        },
      },
      {
        path: "/403",
        name: "Forbidden",
        component: () => import("../../../share/components/ForbiddenPage.vue"),
      },
    ],
  },
];

export default routes;
